import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MipsFileRepositoryItem } from '@models/mips-file-repository.model';

export const MipsFileRepositoryActions = createActionGroup({
  source: 'MIPS File Repository',
  events: {
    'Get Files': emptyProps(),
    'Get Files Success': props<{ files: MipsFileRepositoryItem[] }>(),
    'Get Files Failure': props<{ error: string }>(),

    'Download Document': props<{ submissionId: number; documentId: number; fileName: string }>(),
    'Download Document Success': props<{ blob: Blob; fileName: string }>(),
    'Download Document Failure': props<{ error: string }>(),

    'View Document': props<{ submissionId: number; documentId: number; fileName: string }>(),
    'View Document Success': props<{ blob: Blob; fileName: string }>(),
    'View Document Failure': props<{ error: string }>(),
  }
});
